// extracted by mini-css-extract-plugin
export default {"container":"GenerateDocumentModal_container__qAuUv"};